export const skiplinksThemes = {
    default: {
        menu: {
            border: '1px solid var(--color-base-brand-grey-light)',
            padding: '12px 8px',
        },
        link: {
            padding: '12px 8px',
        },
    },
};
